<template>
  <div>
    <div class="p-lg">
      <h1>Buttons</h1>
      <div class="mb-lg">
        Toggle:
        <span
          @click="toggleDisabled"
          class="cursor-pointer hover:underline">
          disabled
        </span>
        |
        <span
          @click="toggleLoading"
          class="cursor-pointer hover:underline">
          loading
        </span>
      </div>
      <hr />
    </div>

    <div class="p-lg">
      <div class="mb-lg">
        <p><strong>Base Buttons</strong></p>
        <div class="flex flex-row">
          <BaseButton
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </BaseButton>
          <BaseButton
            variant="primaryDark"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </BaseButton>
          <BaseButton
            variant="secondary"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </BaseButton>
          <BaseButton
            variant="secondaryDark"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </BaseButton>
          <BaseButton
            variant="tertiary"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Tertiary
          </BaseButton>
          <BaseButton
            variant="invisible"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Invisible
          </BaseButton>
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Small Buttons</strong></p>
        <div class="flex flex-row">
          <BaseButton
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </BaseButton>
          <BaseButton
            variant="primaryDark"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </BaseButton>
          <BaseButton
            variant="secondary"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </BaseButton>
          <BaseButton
            variant="secondaryDark"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </BaseButton>
          <BaseButton
            variant="tertiary"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Tertiary
          </BaseButton>
          <BaseButton
            variant="invisible"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Invisible
          </BaseButton>
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Link Buttons</strong></p>
        <div class="flex flex-row">
          <ButtonLink
            :to="{ name: 'Contacts' }"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </ButtonLink>
          <ButtonLink
            :to="{ name: 'Contacts' }"
            variant="primaryDark"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </ButtonLink>
          <ButtonLink
            :to="{ name: 'Branding' }"
            variant="secondary"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </ButtonLink>
          <ButtonLink
            :to="{ name: 'Branding' }"
            variant="secondaryDark"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </ButtonLink>
          <ButtonLink
            to="https://signable.co.uk"
            variant="tertiary"
            :disabled="isDisabled"
            class="mr-base">
            Tertiary
          </ButtonLink>
          <ButtonLink
            to="https://signable.co.uk"
            variant="invisible"
            :disabled="isDisabled"
            class="mr-base">
            Invisible
          </ButtonLink>
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Small Link Buttons</strong></p>
        <div class="flex flex-row">
          <ButtonLink
            :to="{ name: 'Contacts' }"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </ButtonLink>
          <ButtonLink
            :to="{ name: 'Contacts' }"
            variant="primaryDark"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </ButtonLink>
          <ButtonLink
            :to="{ name: 'Branding' }"
            variant="secondary"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </ButtonLink>
          <ButtonLink
            :to="{ name: 'Branding' }"
            variant="secondaryDark"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </ButtonLink>
          <ButtonLink
            to="https://signable.co.uk"
            variant="tertiary"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Tertiary
          </ButtonLink>
          <ButtonLink
            to="https://signable.co.uk"
            variant="invisible"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Invisible
          </ButtonLink>
        </div>
      </div>
    </div>
    <div class="p-lg">
      <div class="mb-lg">
        <p><strong>Icon Buttons</strong></p>
        <div class="flex flex-row">
          <IconButton
            icon="plus"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </IconButton>
          <IconButton
            icon="plus"
            variant="primaryDark"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </IconButton>
          <IconButton
            icon="pencil"
            variant="secondary"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </IconButton>
          <IconButton
            icon="pencil"
            variant="secondaryDark"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </IconButton>
          <IconButton
            icon="user"
            variant="tertiary"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base"
          />
          <IconButton
            icon="times"
            variant="invisible"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Icon Link Buttons</strong></p>
        <div class="flex flex-row">
          <IconButtonLink
            :to="{ name: 'Contacts' }"
            icon="plus"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </IconButtonLink>
          <IconButtonLink
            :to="{ name: 'Contacts' }"
            icon="plus"
            variant="primaryDark"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </IconButtonLink>
          <IconButtonLink
            :to="{ name: 'Branding' }"
            icon="pencil"
            variant="secondary"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </IconButtonLink>
          <IconButtonLink
            :to="{ name: 'Branding' }"
            icon="pencil"
            variant="secondaryDark"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </IconButtonLink>
          <IconButtonLink
            to="https://signable.co.uk"
            icon="user"
            variant="tertiary"
            :disabled="isDisabled"
            class="mr-base"
          />
          <IconButtonLink
            to="https://signable.co.uk"
            icon="times"
            variant="invisible"
            :disabled="isDisabled"
            class="mr-base"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Small Icon Buttons</strong></p>
        <div class="flex flex-row">
          <IconButton
            icon="plus"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </IconButton>
          <IconButton
            icon="plus"
            variant="primaryDark"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </IconButton>
          <IconButton
            icon="pencil"
            variant="secondary"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </IconButton>
          <IconButton
            icon="pencil"
            variant="secondaryDark"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </IconButton>
          <IconButton
            icon="user"
            variant="tertiary"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base"
          />
          <IconButton
            icon="times"
            variant="invisible"
            size="small"
            :loading="isLoading"
            :disabled="isDisabled"
            class="mr-base"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Small Link Icon Buttons</strong></p>
        <div class="flex flex-row">
          <IconButtonLink
            :to="{ name: 'Contacts' }"
            icon="plus"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Primary
          </IconButtonLink>
          <IconButtonLink
            :to="{ name: 'Contacts' }"
            icon="plus"
            variant="primaryDark"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Primary Dark
          </IconButtonLink>
          <IconButtonLink
            :to="{ name: 'Branding' }"
            icon="pencil"
            variant="secondary"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Secondary
          </IconButtonLink>
          <IconButtonLink
            :to="{ name: 'Branding' }"
            icon="pencil"
            variant="secondaryDark"
            size="small"
            :disabled="isDisabled"
            class="mr-base">
            Secondary Dark
          </IconButtonLink>
          <IconButtonLink
            to="https://signable.co.uk"
            icon="user"
            variant="tertiary"
            size="small"
            :disabled="isDisabled"
            class="mr-base"
          />
          <IconButtonLink
            to="https://signable.co.uk"
            icon="times"
            variant="invisible"
            size="small"
            :disabled="isDisabled"
            class="mr-base"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import IconButton from '@/components/library/buttons/IconButton.vue';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import IconButtonLink from '@/components/library/links/IconButtonLink.vue';

export default {
  components: {
    BaseButton,
    IconButton,
    ButtonLink,
    IconButtonLink,
  },
  data() {
    return {
      isDisabled: false,
      isLoading: false,
    };
  },
  methods: {
    toggleDisabled() {
      this.isDisabled = !this.isDisabled;
    },
    toggleLoading() {
      this.isLoading = !this.isLoading;
    },
  },
};
</script>
